import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-services11',
  templateUrl: './section-services11.component.html',
  styleUrls: ['./section-services11.component.css']
})
export class SectionServices11Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
